import { createFileRoute } from '@tanstack/react-router';
import { ListPage, blankDraft } from '../features/lists/ListPage';

/**
 * `?base=owners` — start a list of owners rather than tenancies.
 *
 * SHAPE-CHECKED ONLY, as `/automations/new` checks its template: `validateSearch` runs during
 * routing, so importing the list vocabulary here would put it in the eager bundle. Anything but
 * `owners` is a list of tenancies.
 */
export const Route = createFileRoute('/communications/lists/new')({
  validateSearch: (search: Record<string, unknown>): { base?: 'owners' } =>
    search['base'] === 'owners' ? { base: 'owners' } : {},
  component: NewListPage,
});

function NewListPage() {
  const { base } = Route.useSearch();
  return (
    <ListPage key={base ?? 'tenancies'} saved={null} initial={blankDraft(base ?? 'tenancies')} />
  );
}
